import { render, staticRenderFns } from "./ConfirmRemoveTemplateModal.vue?vue&type=template&id=2457bff8&"
import script from "./ConfirmRemoveTemplateModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmRemoveTemplateModal.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmRemoveTemplateModal.vue?vue&type=style&index=0&id=2457bff8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports